import {useQuery} from 'react-query'
import {userUseCase} from '../../factories'

const useListUsers = (variables) => {
    const {
        refetch, isLoadingUsers, data, error,
    } = useQuery('users', () => userUseCase.listUsers(variables))

    return {
        refetch,
        isLoadingUsers,
        error,
        data,
    }
}

export default useListUsers
